export default __webpack_public_path__ + "static/erich-fischer-2013-da1e58942f81f638f70f964aa2008e87.jpg";